import { PERMISSIONS } from '../../../shared/roleAccess/config/roleConfig'

// Add reference links here; grant each permission through ROLE_PERMISSIONS.
export const BRAND_REFERENCE_LINKS = Object.freeze([
  {
    id: 'assethub-project',
    label: 'AssetHub project',
    permission: PERMISSIONS.VIEW_ASSETHUB_PROJECT,
    getHref: ({ brand, env }) => {
      const hostname = env.assethubHostname?.trim().replace(/\/+$/, '')
      return hostname && brand.assetHubProjectUuid
        ? `${hostname}/project/${encodeURIComponent(brand.assetHubProjectUuid)}/dashboard`
        : null
    },
  },
])
